import React from 'react';
import {Box, useColorModeValue, Flex, Stack, Button, Heading} from '@chakra-ui/react';

import {Icon} from '@chakra-ui/react';

const Card = props => {
  return (
    <div>
      <Flex>
        <Box
          as={Button}
          onClick={() => {
            window.location.href = props.route;
          }}
          h={'full'}
          w={'400px'}
          bg={useColorModeValue('tertiary.50', 'gray.500')}
          boxShadow={'2xl'}
          rounded={'md'}
          overflow={'hidden'}
          _hover={{
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
            cursor: 'pointer',
          }}
        >
          <Box p={6}>
            <Stack spacing={0} align={'center'} mb={5}>
              <Icon as={props.icon} h="60" w="60" />
              <Heading fontSize={'2xl'}>{props.name}</Heading>
            </Stack>
          </Box>
        </Box>
      </Flex>
    </div>
  );
};

export default Card;
